import { Styles } from "@react-pdf/renderer";

export const styles: Styles = {
  page: {
    color: "#323539",
    flexDirection: "column",
    fontFamily: "Inter",
    fontSize: 10,
    fontWeight: 400,
    letterSpacing: 0.25,
    paddingBottom: 70,
    paddingLeft: 44,
    paddingRight: 44,
    paddingTop: 58,
    rowGap: 15,
  },
  footer: {
    alignItems: "center",
    backgroundColor: "#DDE7FD",
    bottom: 0,
    flexDirection: "row",
    height: 60,
    justifyContent: "space-between",
    left: 0,
    paddingHorizontal: 44,
    position: "absolute",
    right: 0,
  },
  h1: {
    fontFamily: "Outfit",
    fontSize: 22,
    fontWeight: 500,
    marginBottom: 16,
  },
  h2: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 8,
  },
  h3: {
    fontSize: 14,
    fontWeight: 500,
    marginBottom: 8,
  },
  header: {
    alignItems: "center",
    borderBottomColor: "#C1C3C7",
    borderBottomWidth: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    left: 44,
    paddingVertical: 12,
    position: "absolute",
    right: 44,
    top: 0,
  },
  section: {
    borderBottomColor: "#C1C3C7",
    borderBottomWidth: 1,
    paddingBottom: 15,
  },
  tight: {
    borderBottomWidth: 0,
    margin: 0,
    padding: 0,
  },
  upperfirst: {
    textTransform: "upperfirst",
  },
};
